import { LoanFrequency } from '@/loan/enums/loan-frequency';

export const LOAN_FREQUENCY_MAP: ReadonlyMap<LoanFrequency, string> = new Map<LoanFrequency, string>([
	[
		LoanFrequency.BI_WEEKLY,
		'Bi-Weekly',
	],
	[
		LoanFrequency.MONTHLY,
		'Monthly',
	],
	[
		LoanFrequency.SEMI_MONTHLY,
		'Semi-Monthly',
	],
	[
		LoanFrequency.WEEKLY,
		'Weekly',
	],
]);
